import React, { useState } from 'react';

import styles from './map-modal.module.css';
import { graphql, useStaticQuery } from 'gatsby';

import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

export enum name {
  Prokofieva = 'Prokofieva',
  Baranivska = 'Baranivska',
  Tallinn = 'Tallinn',
}

const contentObj: {
  [key in name]: { title: string; street: string; post: string; phone: string };
} = {
  Prokofieva: {
    title: 'Head office',
    street: 'Prokofieva st. 14 ',
    post: '40001, Sumy, Ukraine',
    phone: '+38 098 546 3429',
  },
  Baranivska: {
    title: 'Brocoders office',
    street: 'Baranivska st. 203',
    post: '40010, Sumy, Ukraine',
    phone: '+38 050 768 7691',
  },
  Tallinn: {
    title: 'Brocoders office',
    street: 'Sakala st. 10',
    post: '10116, Tallinn, Estonia',
    phone: '+38 050 768 7691',
  },
};

const Marker: React.FC<{
  lat: number;
  lng: number;
  name?: keyof typeof name;
}> = ({ name = 'Prokofieva' }) => {
  const [isScale, setIsScale] = useState(false);

  const handleScale = (): void => {
    !isScale && setIsScale(true);
  };

  const handleCloseScale = (): void => {
    setIsScale(false);
  };

  const data = useStaticQuery(graphql`
    query {
      mapPin: file(relativePath: { eq: "map-pin.svg" }) {
        publicURL
      }
      broLogo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 40) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);

  const { title, street, post, phone } = contentObj[name];

  return (
    <div className={cx('container', { markerScale: isScale })}>
      <button
        type="button"
        className={cx(styles.closeBtn, { closeBtnVisible: isScale })}
        onClick={handleCloseScale}
      />
      <button type="button" onClick={handleScale} className={styles.btnContainer}>
        <div className={cx('markerImgContainer')}>
          <img src={data.mapPin.publicURL} className={styles.markerImg} alt="pin" />
          <div className={cx('broData', { broDataVisible: isScale })}>
            <h4 className={styles.title}>{title}</h4>
            <p className={styles.text}>{street}</p>
            <p className={styles.text}>{post}</p>
            {/* <p className={styles.text}>{phone}</p> */}
          </div>
        </div>
        <div className={styles.contentContainer}>
          <img
            src={data.broLogo.childImageSharp.fluid.src}
            className={cx('broLogo', { broLogoHidden: isScale })}
          />
        </div>
      </button>
    </div>
  );
};

export default Marker;
